import { Container, Heading, Text } from '@chakra-ui/react';
import React from 'react';

const Salaries = () => {
    return (
        <Container>
            
        </Container>
    );
};

export default Salaries;